import Splide from '@splidejs/splide';
import {sliderOptions} from '../colorz/configClrzApp';

export default class ClrzSliderNoDefer extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.defaultOptions = sliderOptions.default;
		this.options = !!this.dataset.options
			? sliderOptions[this.dataset.options]
			: {};
		this.options = {...this.defaultOptions, ...this.options};

		// specific dev for this slider, how may have arrows
		if (this.dataset.options == 'js-slider-cart-drawer-side') {
			if (this.dataset.slides > 1) {
				this.options.arrows = true;
			}
		}

		if (this.dataset.destroy == 'true') {
			this.options.destroy = true;
		}

		this.initSlider();
	}

	initSlider() {
		const splide = new Splide(this, this.options);

		splide.on('overflow', function (isOverflow) {
			if (!isOverflow) {
				splide.options = {
					arrows: false,
					pagination: false,
					drag: false,
				};
			}
		});

		splide.mount();

		if (this.dataset.positionArrows == 'true') {
			const topArrow =
				this.querySelector('.splide__slide img')?.offsetHeight / 2;
			this.querySelectorAll('.splide__arrow-wrapper').forEach((arrow) => {
				arrow.style.top = topArrow + 'px';
			});
		}

		const slides = this.querySelectorAll('.splide__slide');

		slides.forEach(function (slide) {
			const noDragElements = slide.querySelector('.js-stop-drag-slider');
			const dragElements = slide.querySelectorAll('.js-drag-slider');

			if (noDragElements) {
				noDragElements.addEventListener('click', function () {
					splide.options = {drag: false};
					if (this.closest('.splide__list.remove-transform')) {
						this.closest('.splide__list.remove-transform').style.transform = '';
					}
				});

				dragElements.forEach(function (element) {
					element.addEventListener('click', function () {
						splide.options = {drag: true};
					});
				});
			}
		});
	}
}
